class ComponentFactory{
    constructor(){
     this.componentList={};
    }
     set(componentName,componentRef){
         this.componentList[componentName]=componentRef;
     }
     get(componentName){
         if(componentName){
             if(this.componentList[componentName])
             return this.componentList[componentName]
             else{
                 console.log("Registered Component Not found")
                 return null;
                
             }
         }
     }
 
 }
 export default new ComponentFactory();